module.exports = __webpack_public_path__ + "img/CH01-046-047.7992ae2c.jpg";